var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCommunicationMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 39 39"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "icon-communication-mobile_svg__a",
  colorInterpolationFilters: "auto"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 0.274510 0 0 0 0 0.176471 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#icon-communication-mobile_svg__a)",
  transform: "translate(-12 -12)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#006FCF",
  fillRule: "nonzero",
  d: "M40.533 12.825a2.375 2.375 0 0 1 2.375 2.375v33.25a2.375 2.375 0 0 1-2.375 2.375H23.117a2.375 2.375 0 0 1-2.375-2.375V15.2a2.375 2.375 0 0 1 2.375-2.375zm-4.75 3.958h-7.916a1.583 1.583 0 0 1-1.584-1.583h-3.166v33.25h17.416V15.2h-3.166c0 .874-.71 1.583-1.584 1.583m-3.958 26.125a1.583 1.583 0 1 1 0 3.167 1.583 1.583 0 0 1 0-3.167"
}))));
export default SvgIconCommunicationMobile;